import { render, staticRenderFns } from "./TransferenciaItemsIngreso.vue?vue&type=template&id=585113a0&scoped=true&"
import script from "./TransferenciaItemsIngreso.vue?vue&type=script&lang=js&"
export * from "./TransferenciaItemsIngreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585113a0",
  null
  
)

export default component.exports